import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'hash',
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: "/index", component: require("@/views/index.vue") },
    { path: "/findUs", component: require("@/views/findUs.vue") },
    { path: "/lifeHome", component: require("@/views/lifeHome.vue") },
    { path: "/serviceRules", component: require("@/views/serviceRules.vue") },
    { path: "/contactUs", component: require("@/views/contactUs.vue") },
    { path: "/case1", component: require("@/views/case1.vue") },
    { path: "/case2", component: require("@/views/case2.vue") },
    { path: "/case3", component: require("@/views/case3.vue") },
    { path: "/case4", component: require("@/views/case4.vue") },
    { path: "/case5", component: require("@/views/case5.vue") },
    { path: "/case6", component: require("@/views/case6.vue") },
    { path: "/case7", component: require("@/views/case7.vue") },
    { path: "/case8", component: require("@/views/case8.vue") },
    { path: "*", redirect: "/index" },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js